import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import '../Styles/RegisterLogin.css';
import img1 from '../../assets/img/Add a heading (11).png';
import logoimg from '../../assets/logo/Add a heading (12).png';

const LoginPage = () => {
  const [captcha, setCaptcha] = useState('');
  const [userCaptcha, setUserCaptcha] = useState('');
  const [isCaptchaValid, setIsCaptchaValid] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    role: '', 
  });
  const [showAlert, setShowAlert] = useState(false);
  const [incorrectCredentials, setIncorrectCredentials] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const randomText = Math.random().toString(36).substring(2, 8).toUpperCase();
    setCaptcha(randomText);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    if (userCaptcha !== captcha) {
      setShowAlert(true);
      setIsCaptchaValid(false);
      setIncorrectCredentials(false);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
  
      setFormData({
        email: '',
        password: '',
        role: '',
      });
      setUserCaptcha('');
      generateCaptcha();
    } else {
      setIsCaptchaValid(true);
  
      // Remove the hardcoded validation for email and password
      if (formData.email && formData.password && formData.role) {
        // Redirect to user profile page if role is selected
        if (formData.role === 'pharmacist' || formData.role === 'distributor' || formData.role === 'ward') {
          navigate('/user-profile', { state: { role: formData.role } });
        }
      } else {
        setIncorrectCredentials(true);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
  
        setFormData({
          email: '',
          password: '',
          role: '',
        });
      }
    }
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleRegisterClick = () => {
    navigate('/register');
  };

  return (
    <div className="login-form-container">
      <div className="left-side">
        <div className="image-container">
          <img src={img1} alt="background" className="animated-image" />
        </div>
        <img src={logoimg} alt="" className="logo" />
        <div className="register-text">
          Don't have an account? 
          <button className="register-btn" onClick={handleRegisterClick}>Register Here!</button>
        </div>
      </div>

      {showAlert && !isCaptchaValid && (
        <div className="alert">
          Captcha Incorrect! Try Again.
        </div>
      )}

      {showAlert && incorrectCredentials && (
        <div className="alert">
          Incorrect Email or Password! Please try again.
        </div>
      )}

      <div className="right-side">
        <form onSubmit={handleSubmit} className="login-form">
          <h2 className='loginhead'>Login</h2>

          <div className="input-field">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-field">
            <label>User Role:</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              required
              className="role-dropdown"
            >
              <option value="">Select Role</option>
              <option value="pharmacist">Pharmacist</option>
              <option value="distributor">Distributor</option>
              <option value="ward">Department</option>
            </select>
          </div>

          <div className="input-field password-container">
            <label>Password:</label>
            <input
              type={isPasswordVisible ? 'text' : 'password'}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />

            <span className="eye-icon" onClick={togglePasswordVisibility}>
              {isPasswordVisible ? '🙈' : '👁️'}
            </span>
          </div>

          <div className="captcha-field">
            <label>Captcha</label>
            <div className="captcha-container">
              <span>{captcha}</span>
            </div>
            <input
              type="text"
              value={userCaptcha}
              onChange={(e) => setUserCaptcha(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="submit-btn">Login</button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
